import { useCallback, useEffect, useRef, useState } from "react";

export function usePlayback(duration) {
  const [t, setT] = useState(0);
  const [playing, setPlaying] = useState(false);
  const [speed, setSpeed] = useState(0.5);
  const tRef = useRef(0);
  const stopAt = useRef(null);

  const setTime = useCallback((v) => { tRef.current = v; setT(v); }, []);

  useEffect(() => {
    if (!playing) return undefined;
    let raf, last = performance.now();
    const step = (now) => {
      const dt = (now - last) / 1000;
      last = now;
      const lim = stopAt.current ?? duration;
      const nt = tRef.current + dt * speed;
      if (nt >= lim) {
        setTime(lim);
        stopAt.current = null;
        setPlaying(false);
        return;
      }
      setTime(nt);
      raf = requestAnimationFrame(step);
    };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [playing, speed, duration, setTime]);

  const play = () => { if (tRef.current >= duration - 0.01) setTime(0); stopAt.current = null; setPlaying(true); };
  const pause = () => setPlaying(false);
  const restart = () => { setTime(0); stopAt.current = null; setPlaying(true); };
  const seek = (v) => { setPlaying(false); stopAt.current = null; setTime(Math.max(0, Math.min(duration, v))); };
  const playRange = (from, to) => { setTime(from); stopAt.current = to; setPlaying(true); };

  return { t, playing, speed, setSpeed, play, pause, restart, seek, playRange, duration };
}
